<template>
    <div>
        <loading-component :value="loading"></loading-component>
        <v-layout>
            <v-flex xs12>
                <v-container>
                    <h2 style="text-align: center">Captain</h2>
                    <v-form ref="captain">
                        <v-text-field
                                label="Ride ID"
                                v-model="captain.ride_id"
                                :rules="numberRules"
                        ></v-text-field>
                        <v-select
                                :items="['Passenger', 'Wasilni']"
                                label="Refunder"
                                v-model="captain.refunder"
                        ></v-select>
                        <v-text-field
                                label="Amount"
                                v-model="captain.amount"
                                :rules="numberRules"
                        ></v-text-field>
                        <v-btn style="display: block;margin-left: auto;margin-right: auto;" @click="repay('captain')">
                            Repay
                        </v-btn>
                    </v-form>
                </v-container>
            </v-flex>
            <v-divider :vertical="true"></v-divider>
            <v-flex xs12>
                <v-container>
                    <h2 style="text-align: center">Passenger</h2>
                    <v-form ref="passenger">
                        <v-text-field
                                label="Booking ID"
                                v-model="passenger.booking_id"
                                :rules="numberRules"
                        ></v-text-field>
                        <v-select
                                :items="['Captain', 'Wasilni']"
                                label="Refunder"
                                v-model="passenger.refunder"
                        ></v-select>
                        <v-text-field
                                label="Amount"
                                v-model="passenger.amount"
                                :rules="numberRules"
                        ></v-text-field>
                    </v-form>
                    <v-btn style="display: block;margin-left: auto;margin-right: auto;" @click="repay('passenger')">
                        Repay
                    </v-btn>
                </v-container>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        name: "Refund",
        components: {LoadingComponent},
        data() {
            return {
                loading: false,
                captain: {refunder: 'Wasilni'},
                passenger: {refunder: 'Wasilni'},
                numberRules: [
                    v => !!v || 'Required field',
                    v => /^[0-9]*$/.test(v) || 'invalid value'
                ],
            };
        },
        methods: {
            repay(provider) {
                if (!this.$refs[provider].validate()) {
                    return;
                }
                this.loading = true;
                let url = '';
                if (provider === 'captain') {
                    url = `ride/${this.captain.ride_id}/refund`;
                } else {
                    url = `booking/${this.passenger.booking_id}/refund`;
                }
                this.axios.put(url, this[provider])
                    .then(() => {
                        this.$refs[provider].reset();
                        this[provider] = {refunder: 'Wasilni'};
                        window.getApp.$emit('SHOW_TOAST', provider + ' refund completed successfully', 'primary');
                    })
                    .catch(err => {
                        console.log(err.message);
                        let message = '';
                        try {
                            message = err.response.data.message;
                        } catch (e) {
                            message = 'failed, Server error';
                        }
                        window.getApp.$emit('SHOW_TOAST', message, 'red');
                    })
                    .finally(() => this.loading = false);
            }
        }
    }
</script>

<style scoped>

</style>